<template>
  <v-card
    class="d-flex flex-column justify-space-between align-center pa-6"
    flat
    tile
    :height="!isMobileBreakpoint ? 548 : '100dvh'"
  >
    <div
      class="w-full d-flex"
      :class="{ 'justify-end': isBatch, 'justify-space-between': !isBatch }"
    >
      <v-btn icon @click="handleBackInitialScreen" v-if="!isBatch">
        <v-icon
          class="close-icon"
          size="24"
          color="grey"
          style="cursor: pointer"
        >
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <v-btn icon @click="handleClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="container-title mb-8">
      <img
        width="66px"
        height="40px"
        :src="require('@/assets/panda-brand-ia.png')"
      />
      <h1 class="body-bold-xlarge mt-2">
        {{
          isSubtitle
            ? $t('message.ai.subtitles.screenTitle.title')
            : $t('message.ai.dubbings.screenTitle.title')
        }}
      </h1>

      <span
        class="body-regular-base neutral-40-light--text text-center mt-2"
        v-html="
          isSubtitle
            ? $t('message.ai.subtitles.screenTitle.description')
            : $t('message.ai.dubbings.screenTitle.description')
        "
      >
      </span>
      <base-btn type="primary" class="mt-4" @click="handleStart">
        {{ $t('message.ai.aiWorkFlowChargeModal.startButton') }}</base-btn
      >
    </div>
    <div>
      <span class="body-regular-small neutral-40-light--text"
        >{{ $t('message.ai.aiWorkFlowChargeModal.billingRulesInfo')
        }}<a
          target="_blank"
          type="secondary"
          size="xsmall"
          :href="$t('message.ai.aiWorkFlowChargeModal.billingRulesInfoHref')"
        >
          {{ $t('message.embedModal.knowMore') }}

          <v-icon size="12">mdi-open-in-new</v-icon>
        </a></span
      >
    </div>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'CheckoutAiTemplate',
  props: {
    type: {
      type: String,
      required: true,
    },
    isBatch: {
      type: Boolean,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    isSubtitle() {
      return this.type == 'Subtitle'
    },
  },
  methods: {
    handleClose() {
      this.$root.$emit(`close${this.type}Modal`)
    },
    handleBackInitialScreen() {
      this.$root.$emit(`back${this.type}InitialScreen`)
    },
    handleBack() {
      this.$root.$emit(`back${this.type}Modal`)
    },
    handleStart() {
      this.$root.$emit(`select${this.type}Screen`)
    },
  },
  beforeDestroy() {
    this.loading = false
  },
  mounted() {
    this.loading = false
  },
}
</script>
<style lang="scss" scoped>
.container-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.w-full {
  width: 100%;
}
</style>
